import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { deleteEpm, deletePlate, deleteSubscription } from 'services/payments-service';
import { TableExt, TableInfo, Confirm, themes, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import EpmForm from 'grids/epm/forms/epm-form';
import RfidForm from 'grids/rfid/forms/rfid-form';
import PlateForm from 'grids/plate/forms/plate-form';
import SubscriptionForm from 'grids/subscription/forms/subscription-form';
import { getTableParams } from './grid.params';
import { getMeanTypeForRight } from './soall.consts';

const forms = {
  rfid: RfidForm,
  card: EpmForm,
  vehicle_plate: PlateForm,
  subscription: SubscriptionForm,
};

const funcs = {
  card: deleteEpm,
  vehicle_plate: deletePlate,
  subscription: deleteSubscription,
};

export const SoAllGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry, getFilter } = props;
  const [showForm, setShowForm] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  const { t } = useTranslation();

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  /**
   * delete item
   */
  const delItem = (id, mean_type) => {
    const test = false;

    const func = funcs[mean_type];
    if (test) {
      console.log('del ' + id, func);
      return;
    }
    if (!func) {
      return;
    }
    func(id).then(() => {
      props.getEntries({ offset: 0 }, null, true);
      closeConfirm();
    });
  };

  const editItemAction = (row) => {
    if (!user.haveRight(getMeanTypeForRight(row.mean_type) + '.update')) {
      return;
    }
    setRow(row);
    setShowForm('editForm');
  };

  const delItemAction = (row) => {
    setRow(row);
    setConfirm({
      title: t('messages.СО') + ' ' + row.mean_id + ' ' + t('messages.будет удалено. Продолжить?'),
      width: '440px',
      type: 'danger',
      cancelButton: { text: t('buttons.Отмена'), func: closeConfirm },
      acceptButton: { text: t('buttons.Удалить'), func: () => delItem(row.id, row.mean_type), theme: themes.red },
    });
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];

  actions.push({
    title: t('buttons.Удалить'),
    action: delItemAction,
    isVisible: (row) => {
      if (row.mean_type === 'rfid') {
        return false;
      }
      return user.haveRight(getMeanTypeForRight(row.mean_type) + '.delete');
    },
  });

  actions.push({
    getTitle: (row) => (row.is_blocked ? t('buttons.Разблокировать ') : t('buttons.Заблокировать ')),
    action: 'status',
    actionType: 'rfid',
    isVisible: (row) => {
      if (row.mean_type !== 'rfid' || row.status === 'blocked_by_client') {
        return false;
      }
      return user.haveRight('rfid.update');
    },
  });

  actions.push({
    title: t('buttons.Перейти в карточку клиента'),
    action: (row) => {
      window.location = '/card/client?id=' + row.client_id;
    },
    isVisible: (row) => {
      if (row.mean_type !== 'rfid') {
        return false;
      }
      if (!row.client_id) {
        return false;
      }
      return user.haveRight('rfid.update') && user.haveRight('clients.view');
    },
  });

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const initial = { ...row };
  const tableParams = useMemo(() => getTableParams(t), [t]);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('soall', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });
  const EditForm = row ? forms[row.mean_type] : null;

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        updateEntry={updateEntry}
        theme={theme}
        title={t('sections.БСК')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={editItemAction}
        getFilter={getFilter}
        {...restTableParams}
        fields={fields}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && (
        <EditForm
          type={showForm}
          close={() => setShowForm('')}
          //id={props.id}
          clientId={props.clientId}
          id={row.id}
          meanId={row.mean_id}
          meanType={row.mean_type}
          refresh={props.refresh}
          tariffs={props.tariffs}
          time_limit_balance={row.time_limit_balance ?? null}
          pending_time_limit_balance={row.pending_time_limit_balance ?? null}
          initialValues={initial}
        />
      )}
    </GridBox>
  );
};
